import { Checkbox, Pane, Paragraph } from 'evergreen-ui';
import React, { memo } from 'react';

import { ValidatedCheckboxField } from '../../../../common';
import {translate} from '../../../../common/util/strings';
import {ResendActivationEmailButton} from './ResendActivationEmailButton';


export function isUserActive(status: string) {
    const isInactive = ['DEACTIVATED', 'SUSPENDED'].includes(status);
    return !isInactive;
}

export function getFriendlyUserStatus(status: string) {
    const beautifulTexts: Record<string, string> = {
        'PROVISIONED': 'Pending User Action',
        'PASSWORD_EXPIRED': 'Password Reset',
    };
    return translate(status, beautifulTexts);
}

type UserStatusProp = {
    oktaId: string;
    status: string;
    canSetUserStatus?: boolean
}
export const UserStatus = memo(function UserStatus({ oktaId, status, canSetUserStatus }: UserStatusProp) {
    // BE only handles these 2 statuses
    const disabled = !['ACTIVE', 'SUSPENDED'].includes(status);
    return (
        <Pane paddingLeft={24} width='100%' marginBottom={24}>
            <Paragraph size={500}>
                Status
            </Paragraph>
            <Paragraph size={400} marginBottom={12} display='flex' alignItems='center'>
                {getFriendlyUserStatus(status)}
                <ResendActivationEmailButton userOktaId={oktaId} status={status}/>
            </Paragraph>
            <ValidatedCheckboxField
                data-testid="um-user-status-input"
                size={400}
                marginY={0}
                name="active"
                disabled={disabled || !canSetUserStatus}
                label={<span className="text-sm font-normal">Active</span>} />
            {!canSetUserStatus &&
                <div className="text-xs text-gray-400">You don't have permission to change this field</div>
            }
        </Pane>
    );
});

export const DummyUserStatus = memo(function DummyUserStatus() {
    return (
        <Pane paddingLeft={24} width='100%' marginBottom={24}>
            <Paragraph size={500} marginBottom={12}>
                Status
           </Paragraph>
            <Checkbox
                size={400}
                marginY={0}
                disabled
                checked
                label={<span className="text-sm font-normal">Active</span>} />
        </Pane>
    );
});
